import WelcomeWidget from "./components/common/widgets/WelcomeWidget/WelcomeWidget";
import RecentUpdatesWidget from "./components/common/widgets/RecentUpdatesWidget/RecentUpdatesWidget";
import TasksWidget from "./components/common/widgets/TasksWidget/TasksWidget";
import StatusWidget from "./components/common/widgets/StatusWidget/StatusWidget";
import MapWidget from "./components/common/widgets/MapWidget/MapWidget";
import BookedGraphWidget from "./components/common/widgets/BookedGraphWidget/BookedGraphWidget";
import BookmarksWidget from "./components/common/widgets/BookmarksWidget/BookmarksWidget";
import "./Dashboard.scss";

function Dashboard({ user_type }: { user_type: string }) {
  const isProvider = user_type === "provider";

  return (
    <>
      <WelcomeWidget />
      <div className="dashboard-grid">
        <div className="grid-item-full">
          <StatusWidget />
        </div>

        {/* Show TasksWidget only if shipper */}
        {!isProvider && (
          <div className="grid-item">
            <TasksWidget />
          </div>
        )}

        <div className="grid-item">
          <RecentUpdatesWidget />
        </div>

        {/* Re-arrange layout based on user type */}
        {isProvider ? (
          <>
            <div className="grid-item">
              <BookedGraphWidget isProvider={isProvider} />
            </div>
            <div className="grid-item">
              <BookmarksWidget />
            </div>
            <div className="grid-item">
              <MapWidget />
            </div>
          </>
        ) : (
          <>
            <div className="grid-item">
              <BookedGraphWidget isProvider={isProvider} />
            </div>
            <div className="grid-item">
              <BookmarksWidget />
            </div>
            <div className="grid-item-full">
              <MapWidget />
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default Dashboard;
